import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectItem } from "app/NativeComponents/snippets";

import {
  bulkUpdateLeads,
  setLeadOwnerModal,
  pushSidePanel,
  numberWithCommas
} from "app/NativeActions";
class AssignLeadButton extends Component {
  render() {
    const { button_search, title, selected_all, selected_leads } = this.props;
    const { token, user, filtered_count } = this.props;

    if (
      !button_search ||
      title.toLowerCase().includes(button_search.toLowerCase())
    ) {
      return (
        <SelectItem
          select_type="none"
          icon="keyboard-arrow-right"
          onPress={() => {
            this.props.setLeadOwnerModal({
              title: "Assign Lead Owner ",
              description: selected_all
                ? numberWithCommas(filtered_count) + " leads"
                : selected_leads.length === 1
                ? selected_leads[0].property_address
                : numberWithCommas(selected_leads.length) + " leads.",
              type: "assign_lead_to_member",
              selected_leads: selected_all ? "all" : selected_leads,

              selected_status: 0,
              modalAction: ({
                selected_leads,
                selected_lead_owner,
                onLoading = () => {},
                onError = () => {},
                onSuccess = () => {}
              }) => {
                onLoading();
                this.props.bulkUpdateLeads({
                  token: token,
                  type: "assign_lead_to_member",
                  assign_to_id: selected_lead_owner,
                  select_all: selected_all ? 1 : 0,
                  total_count: selected_all
                    ? filtered_count
                    : selected_leads.length,
                  filters:
                    this.props.applied_filter &&
                    this.props.applied_filter.filters
                      ? this.props.applied_filter?.filters
                      : null,
                  property_flags: this.props.lead_filters?.property_flags
                    .map(({ value }) => value)
                    .join(","),
                  property_flags_and_or:
                    this.props.lead_filters?.property_flags_and_or,
                  search: this.props.search,
                  search_type: this.props.search_type,
                  list_id: this.props.active_list_tab?.id
                    ? this.props.active_list_tab?.id
                    : this.props.active_list_tab,
                  list_history_id: this.props.list_history_id || "",
                  lead_ids: selected_all
                    ? ""
                    : selected_leads
                        .map(property => {
                          return property.deal.id;
                        })
                        .join(),
                  onLoading: () => {
                    onLoading();
                  },
                  onError: () => {
                    onError();
                  },
                  onSuccess: () => {
                    onSuccess();
                    this.props.clearAll();
                  }
                });
              }
            });

            this.props.pushSidePanel({ slug: "lead_owner", overlay: true });
            this.props.toggleMenu(false);
          }}
        >
          {title}
        </SelectItem>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth }) => {
  const { token, user } = auth;
  return {
    token,
    user
  };
};

export default connect(mapStateToProps, {
  bulkUpdateLeads,
  setLeadOwnerModal,
  pushSidePanel
})(AssignLeadButton);
